export default __webpack_public_path__ + "static/media/verifiable.7aaad91a.png";